import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASEURL + "/api/",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    headers.set("Portal", "customer");
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
      // Attempt token refresh via POST Auth/refresh
      const refreshResult = await baseQuery(
        {
          url: "Auth/refresh",
          method: "POST",
          body: { refreshToken },
        },
        api,
        extraOptions
      );

      if (refreshResult.data && refreshResult.data.accessToken) {
        localStorage.setItem("token", refreshResult.data.accessToken);
        if (refreshResult.data.refreshToken) {
          localStorage.setItem("refreshToken", refreshResult.data.refreshToken);
        }
        // Retry original request
        result = await baseQuery(args, api, extraOptions);
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("userType");
        window.location.href = "/Login";
      }
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("userType");
      window.location.href = "/Login";
    }
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "User",
    "EmailConfig",
    "AccessHistory",
    "SecurityQuestions",
    "EmailHistory",
    "CandidateApps",
    "WorkflowTasks",
    "Documents",
    "Meetings",
    "FormLibrary",
    "ComplianceReport",
    "MonthlyPayCandidates",
    "PartnerCandidates",
    "PartnerUsers",
    "PartnerCandidatesReport",
    "ComponentUserStatus",
    "ReviewNotes",
    "Support",
    "ApplicationSummary",
    "AppUpdates",
    "AppMsgList"
  ],
  endpoints: () => ({}),
});
